const version = "15.6.0";

export default version;


// WEBPACK FOOTER //
// ./src/components/content/version.js